import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { SuspendedAccessLayout } from 'pages/suspended/layout/SuspendedAccessLayout'
import { SuspendedPage } from 'pages/suspended/ui/suspendedPage'

export const SuspendedRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<SuspendedAccessLayout />}>
        <Route path={'/'} element={<SuspendedPage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
